import { useGqlQuery } from '@api/gql/gqlServices'
import {
  GetQuestsByCategoryDocument,
  GetQuestsByCategoryQuery,
  GetSuggestedQuestsDocument,
  GetSuggestedQuestsQuery,
  Quest,
  QuestStatus
} from '@generated/generates'

interface Props {
  categoryId: string
}

const useQuests = ({ categoryId }: Props) => {
  const { data: suggestedQuestData, isLoading: isLoadingSuggestedQuest } =
    useGqlQuery<GetSuggestedQuestsQuery>(GetSuggestedQuestsDocument)

  const { data: questsData, isLoading: isLoadingQuests } = useGqlQuery<GetQuestsByCategoryQuery>(
    GetQuestsByCategoryDocument,
    {
      categoryId: categoryId,
      status: QuestStatus.Live
    }
  )

  const suggestedQuest = suggestedQuestData?.quests[0]

  return {
    isLoadingQuests,
    isLoadingSuggestedQuest,
    suggestedQuest: suggestedQuest,
    quests: (questsData?.quests as Quest[]) || []
  }
}

export default useQuests
